import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {RealCampusHdr} from '../RealCampus/RealCampusHdr';
import {RealCampusFooter} from './RealCampusFooter';
import {RealCampusFeedback} from './RealCampusFeedback';
import {WhoWeAre} from './WhoWeAre';
import {RealCampusSlider} from './RealCampusSlider';



const homepageStyle : React.CSSProperties = {
    width:'100%',

}


const shopSchoolbtn: React.CSSProperties = {
    backgroundColor:'white',
    color:'#040A5E',
    borderRadius:'20px',
    width:'268px',
    height:'42px',
    display:'flex',
    justifyContent:'center',
    padding:'10px',
    marginTop:'15%',
    cursor:'pointer',
    alignItems:'center',
    border:'none',
    ':hover':{
        backgroundColor:'#040A5E',
        border:'1px solid white',
        color:'white'

    }
}

const newDesigns: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/RealCampusImg/RealCampusDesigns.png') +')',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    backgroundPosition:'right',
    height:'460px',
    width:'44%'
}
const designDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    backgroundColor:'#CCD2DB',
    marginTop:'3%',
    justifyContent:'center'
}
const viewDesBtn = Object.assign({},shopSchoolbtn,{
    color:'white',
    border:'none',
    backgroundColor:'#4D5561',
    ':hover':{
        border:'1px solid #4D5561',
        color:'#4D5561',
        backgroundColor:'white'
    }
});

const bannerBtn = Object.assign({},shopSchoolbtn,{
    color:'white',
    backgroundColor:'#1E1F21',
    fontFamily:'BarlowLight',
    marginTop:'18%',
    width:'230px',
    ':hover':{
        border:'1px solid #1E1F21',
        color:'#1E1F21',
        backgroundColor:'white'
}
});
const bannerBtn1 = Object.assign({},shopSchoolbtn,{
    color:'white',
    backgroundColor:'#1E1F21',
    fontFamily:'BarlowLight',
    marginTop:'6%',
    width:'230px',
    marginRight:'8%',
    ':hover':{
        border:'1px solid #1E1F21',
        color:'#1E1F21',
        backgroundColor:'white'
}
});
const viewProds = Object.assign({},viewDesBtn,{
    width:'450px',
    marginBottom:'50px',
    marginTop:'15px',
    height:'50px',
    backgroundColor:'#A4ABB6',
    ':hover':{
        border:'1px solid #4D5561',
        color:'white',
        backgroundColor:'#4D5561'
    }
})
const newDesignsTxt: React.CSSProperties = {
    fontSize:'40px',
    fontFamily:'Lulo',
    color:'white',
    marginBottom:'25px'
}
const designPara: React.CSSProperties = {
    color:'#303030',
    textAlign:'center',
    fontSize:'18px'
}
const newDesignDiv: React.CSSProperties = {
    width:'35%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
}
const brdImgDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    marginTop:'2%'
}
const brandDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center'
}
const brandHdr: React.CSSProperties = {
    fontSize:'40px',
    fontFamily:'Lulo',
    color:'#5E6A74',
    marginBottom:'25px',
    marginTop:'50px'
}
const subbrandHdr: React.CSSProperties = {
    color:'#5E6A74',
    fontSize:'18px',
    textAlign:'center'
}
const brandImg : React.CSSProperties = {
    height:'500px',
    transition:'transform 250ms',
    cursor:'pointer',
    ':hover': {
        transform:'translateY(-15px)'
    },
}
const orderDiv: React.CSSProperties = {
    width:'100%',
    height:'100px',
    backgroundColor:'#4D5561',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    marginTop:"3%",
    flexDirection:'column'
}
const need: React.CSSProperties = {
    color:'white',
    fontFamily:"BarlowMedium",
    fontSize:'17px'
}
const start: React.CSSProperties = {
    color:"white",
    fontFamily:'Lulo',
    textDecoration:'underline',
    fontSize:'17px',
    cursor:'pointer'
}
const bannerImg: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/RealCampusImg/Real_Campus_Banner.png') +')',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    backgroundPosition:'center',
    height:'500px',
    width:'100%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center'
}
const realCampImg: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/RealCampusImg/RC_Logo_Transparent.png') +')',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    backgroundPosition:'center',
    height:'112px',
    width:'42%',
}
const bannerBtnDiv: React.CSSProperties = {
    display:'flex',
}
class Props extends Tgcc.BaseProps{
    ActiveProof: Tgcc.Proof;
}
var category = "Football"

class _RealCampus extends React.Component <Props, any > {
    state = {
        homepage:"",
        help:false
    }

    componentWillMount(){
        if(this.props.location.query.u && this.props.location.query.c){
            var decodedEmail = atob(this.props.location.query.u);
            var decodedToken = atob(this.props.location.query.c);
            this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.ResetPassword, payload: {token: decodedToken, email: decodedEmail}}});
        }
    }

    componentDidMount(){
        var tag = document.getElementById('homepage');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError");
        });
        return false;
    }
    openProofEdit = () => {
        if(this.props.state.LoginData && this.props.state.UserInfo){
            browserHistory.push(Tgcc.Routes.RealCampusProofEdit)
        }
        else {
            browserHistory.push(Tgcc.Routes.RealCampusRegister)
        }    
    };
    openProducts = () =>{browserHistory.push(Tgcc.Routes.RealCampusProductListView)}
    openDesigns = () =>{browserHistory.push(Tgcc.Routes.CampusDesignListView)}
    openAbout = () =>{browserHistory.push(Tgcc.Routes.CampusAbout)}
    openHowItWorks = () => {browserHistory.push(Tgcc.Routes.CampusHowItWorks)};
    openSchool = () => {browserHistory.push(Tgcc.Routes.RealCampusSchools)};
    openComfort = () =>{browserHistory.push(Tgcc.Routes.RealCampusProductView('Comfortwash','GDH100','Deep Forte Blue'))}
    openAlt = () =>{browserHistory.push(Tgcc.Routes.RealCampusProductView('Alternative Apparel','3499',''))}
    openChamp = () =>{browserHistory.push(Tgcc.Routes.RealCampusProductView('Champion','S149','Navy'))}
    openHanes = () =>{browserHistory.push(Tgcc.Routes.RealCampusProductView('Hanes','5250','Cardinal'))}
    requestSchool = () => {
        browserHistory.push(Tgcc.Routes.RealCampusSchoolRequest)
    };


    render() {
        return (
                <div style={homepageStyle}>
                    <div id="homepage"></div>
                    <RealCampusHdr />
                    <div>
                        <div style={bannerImg}>
                            <div style={realCampImg} className="realCampBanner"></div>
                            <div style={bannerBtnDiv}>
                                <div style={bannerBtn} key={8} onClick={this.openSchool}>SHOP BY SCHOOL</div>
                            </div>
                        </div>
                    </div>
                    <RealCampusFeedback state={this.props.state} />
                    <div style={orderDiv}>
                        <div style={need}>Need shirts for you organization?</div>
                        <div style={start} onClick={this.openProofEdit}>START AN ORDER</div>
                    </div>
                    <div style={brandDiv}>
                        <div style={brandHdr} className="brandWe">BRANDS WE LOVE</div>
                        <div style={subbrandHdr}>Learn more about our Authentic Brands <br/> by clicking any apparel below!</div>
                        <div style={brdImgDiv} className="brandPrd">
                            <img key={4} className="prodImg" onClick={this.openAlt} style={brandImg} src={Tgcc.ResolveUrl('~/images/RealCampusImg/3499-01.png')} />
                            <img key={6} className="prodImg" onClick={this.openHanes} style={brandImg} src={Tgcc.ResolveUrl('~/images/RealCampusImg/5250-01.png')} />
                            <img key={5} className="prodImg" onClick={this.openChamp} style={brandImg} src={Tgcc.ResolveUrl('~/images/RealCampusImg/S149-01.png')} />
                            <img key={3} className="prodImg" onClick={this.openComfort} style={brandImg} src={Tgcc.ResolveUrl('~/images/RealCampusImg/GHD100-01.png')} />
                        </div>
                        <div style={viewProds} onClick={this.openProducts}>VIEW ALL PRODUCTS</div>
                    </div>                   
                    <div style={designDiv} className="newDesDiv">
                        <div style={newDesignDiv} className="inDesDiv">
                            <div style={newDesignsTxt} className="desTxt">NEW DESIGNS</div>
                            <div style={designPara}>Whether you're ordering for an event, or just general merch for your organization - we've got you covered! Search by keyword or category to find your perfect design.</div>
                            <div key={2} style={viewDesBtn} onClick={this.openDesigns}>View Designs</div>
                        </div>
                        <div style={newDesigns} className="newShirtDiv"></div>
                    </div> 
                    <RealCampusSlider state={this.props.state} />                  
                    <WhoWeAre />
                    <div style={orderDiv}>
                        <div style={need}>Don't see your school or organization?</div>
                        <div style={start} onClick={this.requestSchool}>REQUEST TO ADD!</div>
                    </div>                
                    <RealCampusFooter state={this.props.state} />
                </div>
        );
    }
}


var radiumRealCampusPage = Radium(_RealCampus);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { ActiveProof: state.ActiveProof,
             state:state}
};
export var RealCampus = connect(mapStateToProps)(radiumRealCampusPage);



